"use client";

import React from "react";
import { motion } from "framer-motion";
import { Building2, ShoppingBag, UtensilsCrossed, Route, Briefcase, Compass } from "lucide-react";
interface UseCaseItem {
  title: string;
  icon: React.ComponentType<{
    className?: string;
  }>;
}
const USE_CASES: UseCaseItem[] = [{
  title: "Stadtbesichtigungen",
  icon: Building2
}, {
  title: "Einkaufstouren",
  icon: ShoppingBag
}, {
  title: "Restaurantbesuche",
  icon: UtensilsCrossed
}, {
  title: "Mehrere Zwischenstopps",
  icon: Route
}, {
  title: "Geschäftstermine",
  icon: Briefcase
}, {
  title: "Flexibles Sightseeing",
  icon: Compass
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.08,
      delayChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 16
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.45,
      ease: [0.21, 0.47, 0.32, 0.98]
    }
  }
};
export default function UseCases() {
  return <section id="idealforusecases" data-nav="light" className="bg-background text-foreground py-16 sm:py-20 lg:py-24 border-b border-border/40">
      <div className="max-w-[1136px] mx-auto px-6">
        {/* Header Block */}
        <div className="mb-10 sm:mb-12">
          <div className="flex items-center gap-2 mb-3">
            <span className="size-2 rounded-xs bg-[#D99000] shrink-0" aria-hidden="true" />
            <span className="h-px w-8 bg-border" aria-hidden="true" />
          </div>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-[#324A6D]">
            Perfekt für
          </h2>
        </div>

        {/* Use Cases Grid */}
        <motion.div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: "-40px"
      }}>
          {USE_CASES.map((item, index) => {
          const Icon = item.icon;
          return <motion.div key={item.title} data-index={index} variants={itemVariants} className="group bg-card text-card-foreground border border-[#D9E1E2] rounded-2xl p-5 sm:p-6 shadow-xs hover:border-[#D99000] hover:shadow-md transition-[border-color,box-shadow] duration-200 flex items-center gap-4 sm:gap-5">
                <div className="size-12 rounded-xl bg-background border border-border text-foreground flex items-center justify-center shrink-0 transition-colors duration-200 group-hover:bg-[#FCEBD0] group-hover:text-[#D99000] group-hover:border-[#D99000]" aria-hidden="true">
                  <Icon className="size-5" />
                </div>
                <h3 className="text-lg font-semibold text-foreground tracking-normal">
                  {item.title}
                </h3>
              </motion.div>;
        })}
        </motion.div>
      </div>
    </section>;
}